import { cn } from '#/lib/utils';

import { initiativeItems } from '../content';
import { AnimatedBorderGenerator } from './AnimatedPathGenerator';

export function InitiativesBlock({
  iconBlockId,
  className,
}: {
  iconBlockId: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        // h-[320px] matches AvatarBlock; justify-between spreads the rows to fill it
        'bg-charcoal rounded-14 px-20 py-30 flex flex-col justify-between w-[280px] h-[320px] relative',
        className,
      )}
    >
      <AnimatedBorderGenerator
        topMotionId={`${iconBlockId}-top-motion`}
        bottomMotionId={`${iconBlockId}-bottom-motion`}
        borderRadius={14}
        strokeWidth={1}
      />
      {initiativeItems.map(({ text, icon }) => (
        <div key={text} className="flex gap-8 items-start">
          <div className="size-23 shrink-0 rounded-full bg-cipher-05 text-cloud flex items-center justify-center">
            {icon}
          </div>
          <span className="text-16 font-[500] leading-140 text-cloud">
            {text}
          </span>
        </div>
      ))}
    </div>
  );
}
